import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import { LoginPage } from '@/spa/pages/LoginPage'
import { routeErrorComponent } from './_shared/RouteError'

// Search params on /login:
//   redirect — the path the auth guard bounced from. Used after successful
//   login to return the user where they originally tried to go.
const Search = z.object({
  redirect: z.string().optional(),
})

export const Route = createFileRoute('/login')({
  validateSearch: Search.parse,
  component: LoginPage,
  errorComponent: routeErrorComponent,
})
